import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";

export class InstitutionList {
  constructor(
    private readonly dispatcher: QueryDispatcher,
    private readonly frontend,
  ) { }

  async run(country_code:string, provider_name:string, company_id:Number): Promise<any> {
    let args = { 
        country_code: country_code,
        provider_name: provider_name,
        company_id: company_id
    }
    this.frontend.institution_loading = true
    let res = await this.dispatcher.dispatch('institution_list.data', args)
    if (res.status === '200') {
      this.frontend.institution_list = res.data
      this.frontend.institution_list = this.frontend.institution_list.map((item) => {return item.name})
      this.frontend.original_institution_list = res.data
    } else {
      return res.data
    }
    this.frontend.institution_loading = false
  }
}